"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OneJobAtATimeQueue = void 0;
const tslib_1 = require("tslib");
const core_common_1 = require("@smallstack/core-common");
const rxjs_1 = require("rxjs");
class OneJobAtATimeQueue {
    constructor() {
        this.queue = [];
        this.isRunning = false;
    }
    run(id, f) {
        const alreadyQueued = this.queue.find((job) => job.id === id);
        if (alreadyQueued) {
            return new Promise((resolve) => alreadyQueued.result.subscribe((res) => resolve(res)));
        }
        const result = new rxjs_1.Subject();
        this.queue.push({ id, f, result });
        if (!this.isRunning) {
            this.isRunning = true;
            void this.drainQueue();
        }
        return new Promise((resolve) => result.subscribe((res) => resolve(res)));
    }
    drainQueue() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            while (this.queue.length > 0) {
                const job = this.queue[0];
                try {
                    job.result.next(yield job.f());
                }
                catch (e) {
                    core_common_1.Logger.error("OneJobAtATime", e);
                    job.result.next(undefined);
                }
                finally {
                    this.queue.shift();
                }
            }
            this.isRunning = false;
        });
    }
}
exports.OneJobAtATimeQueue = OneJobAtATimeQueue;
